export const libraryData = {
    header: {
        title: "Resources, Events and Webinars",
        subtitle: "Explore our resources and guides. Get information about events and webinars."
    },
    nav: [
        { href: "#events", label: "Events" },
        { href: "#webinars", label: "Webinars" },
        { href: "#guides", label: "Guides" },
        { href: "#blog", label: "Blog" }
    ],
    sections: [
        {
            id: "events",
            title: "Latest events",
            seo:{
                title: "Admissions Events & Workshops | GradBrew",
                description: 'Join GradBrew live events and workshops on MBA, MiM and Masters admissions — application strategy, essays, scholarships and Q&A with admitted-school mentors.',
                keywords:[],
                image:''
            },
            items: [
                // {
                //     href: "/event/get-ahead-by-switching-to-continuous-performance-management-birmingham",
                //     target:'_blank',
                //     img: {
                //         src: "/Birmingham-workshop.jpg",
                //         alt: "In-person workshop | Birmingham"
                //     },
                //     tag: "Workshop",
                //     date: {
                //         day: "Tuesday",
                //         date: "12 Aug",
                //         year: "2025",
                //         time: "2:00 pm",
                //         tz: "BST"
                //     },
                //     title: "Get ",
                //     linkText: "See event details"
                // },
            ]
        },
        {
            id: "webinars",
            title: "Latest webinars",
            seo: {
                title: "MBA & Masters Admissions Webinars | GradBrew",
                description: 'Watch GradBrew webinars on getting into top MBA, MiM and Masters programs — application timelines, essay craft, school selection and admissions Q&A with expert mentors.',
                keywords: [],
                image: ''
            },
            viewAll: { href: "/resource/webinars", label: "View all webinars" },
            items: [
                // {
                //     href: "/resource/webinars/updated-employment-law-changes-are-you-ready",
                //     target:'_blank',
                //     img: {
                //         src: "/Branded.jpg",
                //         alt: "webinar: Updated employment law changes"
                //     },
                //     title: "Updated employment law changes: Are you ready?",
                //     linkText: "Get webinar details"
                // },
            ]
        },
        {
            id: "guides",
            title: "Latest guides",
            seo: {
                title: "MBA & Masters Admissions Guides | GradBrew",
                description: 'Free GradBrew guides to MBA, MiM and Masters admissions — essay frameworks, school shortlisting, scholarships and ethical application strategy from expert mentors.',
                keywords: [],
                image: ''
            },
            viewAll: { href: "/resource/guides", label: "View all guides" },
            items: [
                {
                    href: "/guide/Part1.pdf",
                    target:'_blank',
                    img: {
                        src: "/Blog 1_What_is_Ethical_Consulting.png",
                        alt: "What Is Ethical Consulting and Why GradBrew Was Born to Redefine It"
                    },
                    title: "What Is Ethical Consulting and Why GradBrew Was Born to Redefine It",
                    desc: "Where Most Clients Get It Wrong <br />They call it the “customer lifecycle.”",
                    linkText: "Download"
                },
                {
                    href: "/guide/Part2.pdf",
                    target:'_blank',
                    img: {
                        src: "/Blog 2_behind_the_curtain.png",
                        alt: "Behind the curtain, who's really writing your application?"
                    },
                    title: "Behind the curtain, who's Really writing your application?",
                    desc: "Let’s talk about the part no one talks about. The back-end of this industry.",
                    linkText: "Download"
                },
                {
                    href: "/guide/Part3.pdf",
                    target:'_blank',
                    img: {
                        src: "/Blog 3_What_sets_gradbrew_apart.png",
                        alt: "What sets GradBrew Apart"
                    },
                    title: "What sets GradBrew Apart",
                    desc: "Why should you be there? What will you bring to the classroom, the cohort, the culture?",
                    linkText: "Download"
                },
            ]
        }
    ]
};